export default __webpack_public_path__ + "static/media/aac.7c20f791.svg";